export const DISPLAY_CONFLICT_DATE_LIMIT = 5;
